import {signal} from "@preact/signals-react";

interface WhitelabelStore {
    stripePublicKey: string;
    googleMapsApiKey: string
}


export const whiteLabelStore = signal<WhitelabelStore>()

export const patchWhiteLabelStore = (partial: Partial<WhitelabelStore>) => {
    if(!whiteLabelStore.value) {
        whiteLabelStore.value = {} as WhitelabelStore
    }
    whiteLabelStore.value = {...whiteLabelStore.value, ...partial}
}